import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React, { useContext, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { DigitalClock } from "@mui/x-date-pickers";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useBebackApi } from "../hooks/useBebackApi";
import UserContext from "../context/UserContext";
import WorkOrderContext from "../context/WorkOrderContext";
import StoreContext from "../context/StoreContext";
import ConfirmationAlert from "./ConfirmationAlert";
import FeedbackContext from "../context/FeedbackContext";
import SmsContext from "../context/SmsContext";

const TimePickerModal = ({
  open,
  close,
  previousTime,
  maxTime,
  closeAll,
  workOrder,
  setAlert,
  setPromisedTimeButton,
}) => {
  const { postMarshalSMS } = useBebackApi();
  const [newTime, setNewTime] = useState(previousTime.plus({ minutes: 15 }));
  const [openConfirmationAlert, setOpenConfirmationAlert] = useState(false);
  const { fetchWorkOrders } = useContext(WorkOrderContext);
  const { username } = useContext(UserContext);
  const { storeId } = useContext(StoreContext);
  const { setIsLoading } = useContext(FeedbackContext);
  const { setSendingSms, setMessageType } = useContext(SmsContext);

  const handleChangeTime = async () => {
    setIsLoading(true);
    const messageType = 'promisedTimeMessageUpdate'
    setSendingSms((prev) => { 
      return [
        ...prev, 
        {
          wo: workOrder.WO,
          messageType: messageType
        }
      ]
    })
    setMessageType(messageType)
    const res = await postMarshalSMS({
      phoneNumber: workOrder.Phone,
      sentCount: workOrder.MarshalSmsCount,
      siteNo: workOrder.SiteNo,
      messageType: messageType,
      woNumber: workOrder.WO,
      username,
      messageContent: {
        timestamp: newTime.toUTC(),
      },
      promised_time_details: workOrder.promised_time_details || null,
    });
    if (res && !res.error) {
      setOpenConfirmationAlert(false);
      setAlert(false);
      setPromisedTimeButton(false);
      closeAll();
      close();
      setIsLoading(false);
    } else {
      await fetchWorkOrders(storeId);
      setIsLoading(false);
      alert("There was an error while updating the promise time");
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={close}
        disableEscapeKeyDown
        maxWidth="xs"
        fullWidth={true}
      >
        <div className="flex justify-between">
          <DialogTitle>Change time</DialogTitle>
          <IconButton
            aria-label="close modal"
            sx={{ padding: 1, margin: 1, height: "fit-content" }}
            onClick={close}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <DialogContent dividers>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3 text-red-500">
              <AccessTimeIcon />
              {previousTime.toFormat("hh:mm a")}
            </div>
            <ArrowForwardIcon />
            <div className="flex items-center gap-3 text-green-700">
              <AccessTimeIcon />
              {newTime.toFormat("hh:mm a")}
            </div>
          </div>
          <DigitalClock
            value={newTime}
            onChange={(newValue) => setNewTime(newValue)}
            skipDisabled
            minTime={previousTime.plus({ minutes: 15 })}
            timeStep={15}
            maxTime={maxTime}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="text" color="error" onClick={close}>
            Cancel
          </Button>
          <Button
            variant="text"
            color="error"
            className="font-bold"
            onClick={() => setOpenConfirmationAlert(true)}
          >
            Save new time
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmationAlert
        className="max-w-md mx-auto"
        open={openConfirmationAlert}
        close={() => setOpenConfirmationAlert(false)}
        handleConfirm={handleChangeTime}
        title="Send new message?"
        confirmMessage="Send Message"
        rejectMessage="Cancel"
        message={
          <div className="flex gap-6">
            <AccessTimeIcon />
            <div className="font-bold">
              Do you want to send the customer this message?
              <div className="font-normal">
                "Les Schwab: Your new pickup time is{" "}
                {newTime.toFormat("hh:mm a")}. Thank you for your
                understanding."
              </div>
            </div>
          </div>
        }
      />
    </>
  );
};

export default TimePickerModal;
